// extracted by mini-css-extract-plugin
module.exports = {"root":"ConfettiCannon__root___KdK45","canvas":"ConfettiCannon__canvas___AJHns"};